import styled from "styled-components";

export const QuickTestFormStyled = styled.div`
  .box_input_group_quizz {
    .input_wrap {
    }
    .passed_label {
      margin-top: 20px;
      margin-bottom: 0.5rem;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_11};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
    .btn_submit_wrap {
      margin: auto;
      margin-top: 20px;
      max-width: 215px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.IPAD}) {
    .box_input_group_quizz {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
    }
  }
`;
